import axios from 'axios'
import { interceptor } from '@/application/utils/interceptor.js'

const domain = process.env.VUE_APP_API_PATH
const invoiceApi = `${domain}api/v1/dashboard/invoice`

export const getInvoiceByToken = (token) => interceptor(axios).get(invoiceApi, { params: { token } })
export const getInvoiceById = (id) => interceptor(axios).get(invoiceApi, { params: { id } })
